<template>
  <ul
    class="footer-navigation__columns md:hidden"
    role="list"
  >
    <li
      v-for="group in accordion"
      :key="group.title"
      class="footer-navigation__column"
      :class="{ 'footer-navigation__column--open': group.show }"
    >
      <h2
        class="footer-navigation__column-title md font-semibold normal-case flex items-center justify-between"
        @click="group.show = !group.show"
      >
        {{ group.title }}
        <div class="plus-icon" />
      </h2>
      <Vue3SlideUpDown
        v-model="group.show"
        :duration="accordionDuration"
      >
        <ul class="footer-navigation__list">
          <li
            v-for="link in group.links"
            :key="link.url"
            class="footer-navigation__list-item"
          >
            <a
              :href="link.url"
              class="footer-navigation__link"
            >
              {{ link.title }}
            </a>
          </li>
        </ul>
      </Vue3SlideUpDown>
    </li>
  </ul>
</template>

<script>
import { Vue3SlideUpDown } from "vue3-slide-up-down"


export default {
  components: {
    Vue3SlideUpDown,
  },
  props: {
    accordionData: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      accordion: [...this.accordionData],
      accordionDuration: 300
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
